import { logger } from '@utils/logger';

export const captureError = (error: unknown, variables?: unknown, context?: unknown) => {
  const prefix = context ? `[${context}] ` : '';
  const message = (error as Error).message || 'Uncaught error';

  logger.error(`${prefix}${message}`, { error, variables });
};
